import { TextColor } from '../../../Home.type'

export function getInverse(contentColor: TextColor): boolean {
	return Boolean(contentColor === TextColor.White)
}
